import { generatePath, Navigate } from "react-router-dom";
import { RESIGNATION_REQUEST_PATH } from "@/modules/requests/pages/resignation-request";

export function OpenResignationRequest() {
  const requestId = new URL(window.location.href).searchParams.get("id");

  if (!requestId) {
    return null;
  }

  return (
    <Navigate
      to={generatePath(RESIGNATION_REQUEST_PATH, {
        requestId,
      })}
    />
  );
}
